import React from 'react';
import { FaEthereum } from 'react-icons/fa';
import humanLogo from '../../human.svg';

function AssetList({ tokens, isLoading }) {
  return (
    <section className="widget assets">
      <h2><FaEthereum /> Assets</h2>
      {isLoading ? (
        <p>Loading assets...</p>
      ) : (
        tokens.map((token, index) => (
          <div key={index} className="asset-item" title={token.symbol === 'HUMAN' ? 'ICO coming soon' : ''}>
            {token.symbol === 'HUMAN' ? (
              <div className="human-token">
                <img src={humanLogo} alt="Human Logo" className="human-logo" />
                <span>Human</span>
              </div>
            ) : (
              <span>{token.symbol}</span>
            )}
            <span>{parseFloat(token.balance).toFixed(4)}</span>
          </div>
        ))
      )}
    </section>
  );
}

export default AssetList;